import { toggleModal } from "../../../components/shared-components/modals/actions";
import LogoutOverlay from "../../../components/shared-components/LogoutOverlay";

export async function logout() {
  if (!wattpad.testGroups.IS_LOGOUT_API) {
    window.localStorage.clear();
    wattpad.utils.redirectToServer("/logout");
    return;
  }

  window.store.dispatch(
    toggleModal({
      component: LogoutOverlay,
      disableClose: true,
      hideClose: true,
      useGlobalModalContainer: true,
      className: "logout-overlay"
    })
  );

  try {
    var res = await fetch("/auth/logout", { method: "POST" });
    var data = await res.json();
    if (data.redirectUrl) {
      window.localStorage.clear();
      window.location.href = data.redirectUrl;
    } else {
      throw new Error(data);
    }
  } catch (e) {
    window.store.dispatch(toggleModal());
    wattpad.utils.showToast(
      wattpad.utils.trans(
        "We couldn't log you out. Please try again in a moment."
      )
    );
  }
}
